import { SET_FOOTER_STATE } from "core-web/state/models/Footer/constants";
import store from "core-web/state/store";

export const setFooterState = (footerState) => (dispatch) => {
    dispatch({
        type: SET_FOOTER_STATE,
        footerState,
    });
};

export default (footerState) => store.dispatch(setFooterState(footerState));
